import React, { ChangeEvent } from "react";
import {
  Table, Input, Row, Col, Pagination, Button, Spin, notification, 
  Modal, Popconfirm, Breadcrumb, Space, Empty,
} from "antd";
import { connect } from "react-redux";
import Column from "antd/lib/table/Column";
import { RootStoreModel } from "../../redux/reducers";
import { Link, NavLink, RouteComponentProps } from "react-router-dom";
import { PlusOutlined } from "@ant-design/icons";
import {  BasicStateForListModel } from "../models";

import { CancelTokenSource, IsCancel } from "../../axios/axios.core";
import { getTags, addTag, deleteTag } from "../../axios/api.account";
import { gaEvent } from "../../withTracker"
import { v4 as uuidv4 } from "uuid";

import { Translation } from "react-i18next";

interface stateModel extends BasicStateForListModel {
  isModalVisible: boolean;
  tagName: string;
  tagValues: any[];
  search: string;
  id: string;
}

interface propsModel extends RouteComponentProps<any, any, any> { }

const mapStatetoProps = (state: RootStoreModel) => ({});

class TagListPage extends React.Component<propsModel, stateModel> {
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      isModalVisible: false,
      tagName: "",
      tagValues: [{ id: uuidv4(), value: "" }],
      search: "",
      id: ""
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    this.getList();
  }

  componentDidUpdate(prevProps: propsModel) { }

  componentWillUnmount() {
    // this.setState = () => { }
    this.cancelToken.cancel("cancel axios http request");
  }

  onSearch = () => {
    this.getList(1);
  };

  getList = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    const { search } = this.state;
    this.setState({ loading: true });
    getTags({ pageIndex, pageSize, search }).then((res) => {
      this.setState({
        data: res.dataList,
        loading: false,
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        totalCount: res.totalCount,
      });
    });
  };

  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteTag(id).then(() => {
      notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
      this.setState({ loading: false });
      this.getList(1);
    });
  };

  onOk = () => {
    console.log(this.state.tagName, this.state.tagValues);
    const { tagName, tagValues } = this.state;
    if (!tagName) {
      notification.warning({ message: <Translation>{t => {return t("请输入名称")}}</Translation> });
      return;
    }
    const values = tagValues
      .filter(({ id, value }) => value)
      .map(({ value }) => value);
    if (values.length < 1) {
      notification.warning({ message: <Translation>{t => {return t("请输入值")}}</Translation> });
      return;
    }
    this.setState({ loading: true });
    addTag({ id: this.state.id, key: tagName, values: tagValues }).then(() => {
      notification.success({ message: <Translation>{t => {return t("提交成功")}}</Translation> });
      this.setState({ loading: false, isModalVisible: false });
      this.getList(1);
      this.onCancel();
    },()=>{
      this.setState({ loading: false });
    });
  };

  onAddTagInput = () => {
    this.setState(({ tagValues }) => {
      return {
        tagValues: [
          ...tagValues,
          {
            id: uuidv4(),
            value: "",
          },
        ],
      };
    });
  };

  onRemoveTagInput = (id: string) => {
    this.setState(({ tagValues }) => {
      return {
        tagValues: tagValues.filter((item) => item.id !== id),
      };
    });
  };

  onTagInputChange = (id: string, value: string) => {
    this.setState(({ tagValues }) => {
      return {
        tagValues: tagValues.map((item) => {
          if (item.id === id) {
            return { id, value };
          } else {
            return item;
          }
        }),
      };
    });
  };

  onEdit = (item: any) => {
    const { id, key, values } = item;
    this.setState({
      isModalVisible: true,
      id: id,
      tagName: key,
      tagValues: values
    });
  };

  onCancel = () => {
    this.setState({
      isModalVisible: false,
      id: "",
      tagName: "",
      tagValues: [{ id: uuidv4(), value: "" }]
    });
  };

  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isModalVisible,
      tagName,
      tagValues,
      search,
      id
    } = this.state;
    // console.log(columns)
    return (
      (<Translation>{t => {
          return (
            (<div>
              <div className="breadcrumbTop py-2">
                <Breadcrumb>
                  <Breadcrumb.Item>{t("设备")}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t("设备组")}</Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{padding: "32px 0 11px 0"}}>
                    <Space>
                        <img src="/images/tagIcon.svg" alt="" />
                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("设备组")}</span>
                    </Space>
                </Row>
              </div>
              <Spin spinning={false}>
                <Row style={{ width: "100%" }}>
                  <div className="borderBox">
                    <Row className="mb-3">
                      <Col>
                      {t("名称")}:
                        <Input style={{ width: "200px" ,marginLeft:10}} placeholder={t("输入名称搜索")} value={search} onChange={(e) => this.setState({ search: e.target.value })}></Input>
                      </Col>

                      <Col offset={1}>
                        <Button type="primary" onClick={() => { this.onSearch(); gaEvent("tags", "onClick", "onSearch") }}>
                          {t("查询")}
                        </Button>
                      </Col>

                    </Row>
                  </div>
                  <div className="borderBox">
                    <Row style={{marginBottom: 8 }}>
                      <Col className="ms-auto">
                        <Button
                          type="primary"
                          onClick={() => this.setState({ isModalVisible: true })}
                        >
                          <PlusOutlined />
                          {t("添加设备组")}
                        </Button>
                      </Col>
                    </Row>
                    <Table
                      size="middle"
                      loading={loading}
                      dataSource={data}
                      pagination={false}
                      onChange={(pagination) => { }}
                      locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                    >
                      <Column
                        key="key"
                        dataIndex="key"
                        title={t("名称")}
                      // render={() => 123}
                      ></Column>
                      <Column
                        key="values"
                        dataIndex="values"
                        title={t("值")}
                        render={(v, d) => {
                          if (Array.isArray(v)) {
                            return v.map(
                              
                              ({ value }, i) => (<Row>{value}</Row>)
                              
                            );
                          }
                        }}
                      ></Column>
                      <Column
                        key="values"
                        dataIndex="values"
                        title={t("设备")}
                        render={(v, d: any) => {
                          if (Array.isArray(v)) {
                            return v.map(
                              ({ id, value, count }, i) => (
                                 <Row>{count == 0 ? count : <NavLink style={{textDecoration:"underline"}} to={{ pathname: `/home/devices/groupDevices/${id}`, state: {id: id, value: value,key: d.key } }} >{count}</NavLink>}</Row>)
                            );
                          }
                        }}
                      ></Column>
                      <Column
                        key="operation"
                        dataIndex="id"
                        title={t("操作")}
                        render={(v: string, d: any) => {
                          return (
                            <Space size={8}>
                              <Button type="link" size="small" onClick={() => this.onEdit(d)}>
                                {t("编辑")}
                              </Button>
                              <Popconfirm
                                title={`${t("确认删除设备组")} ${d.key}？`}
                                onConfirm={() => this.onDelete(v)}
                                okText={t("确认")}
                                cancelText={t("取消")}
                              >
                                <Button type="link" ghost size="small">
                                  {t("删除")}
                                </Button>
                              </Popconfirm>
                            </Space>
                          );
                        }}
                      ></Column>
                    </Table>
                    <Pagination
                      style={{ textAlign: "right", marginTop: "20px" }}
                      pageSize={pageSize}
                      current={pageIndex}
                      total={totalCount}
                      showTotal={(total, range) =>
                        `${range[0]}-${range[1]} / ${total} ${t("条")}`
                      }
                      onChange={(page, pageSize) => {
                        this.getList(page, pageSize);
                      }}
                      onShowSizeChange={(current, size) => this.getList(current, size)}
                    ></Pagination>
                  </div>
                </Row>
              </Spin>
              <Modal
                maskClosable={false}
                title={id ? t("修改设备组") : t("添加设备组")}
                confirmLoading={loading}
                destroyOnClose={true}
                open={isModalVisible}
                onOk={() => this.onOk()}
                onCancel={() => this.onCancel()}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Row>
                  <Col span={24}>
                    <label htmlFor="">{t("名称")}</label>
                    <div>
                      <Input
                        placeholder={t("名称")}
                        value={tagName}
                        onChange={(e) => this.setState({ tagName: e.target.value })}
                      ></Input>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col span={18}>
                    <label htmlFor="">{t("值")}</label>
                  </Col>
                </Row>
                {tagValues.map(({ id, value }, index) => {
                  return (
                    <Row className="mb-1" key={id} justify="space-between">
                      <Col span={20}>
                        <div>
                          <Input
                            placeholder={t("值")}
                            value={value}
                            onChange={(e) =>
                              this.onTagInputChange(id, e.target.value)
                            }
                          ></Input>
                        </div>
                      </Col>
                      <Col>
                        {/* <label className="invisible">-</label> */}
                        <div>
                          <Button
                            type="dashed"
                            disabled={index === 0 ? true : false}
                            onClick={() => { this.onRemoveTagInput(id); gaEvent("tags", "onClick", "onRemoveTagInput") }}
                          >
                            -
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  );
                })}
                <Row className="mt-3">
                  <Col span={24}>
                    <Button type="dashed" onClick={() => { this.onAddTagInput(); gaEvent("tags", "onClick", "onAddTagInput") }} block>
                      +{t("添加设备组")}
                    </Button>
                  </Col>
                </Row>
                <div></div>
                <div></div>
              </Modal>
            </div>)
          );
        }}</Translation>)
    );
  }
}

export default connect(mapStatetoProps, {})(TagListPage);
